import { create } from 'zustand';
import { COMMUNITY_SERVER_ID } from '@disenchantment/shared';
import type { Server } from '@disenchantment/types';

interface ServersState {
  servers: Server[];
  activeServerId: string | null;
  setServers: (servers: Server[]) => void;
  addServer: (server: Server) => void;
  setActiveServer: (id: string | null) => void;
  clear: () => void;
}

export const useServersStore = create<ServersState>((set) => ({
  servers: [],
  // Always starts on the community server — there is only one.
  activeServerId: COMMUNITY_SERVER_ID,
  setServers: (servers) => set({ servers }),
  addServer: (server) => set((s) => ({ servers: [...s.servers, server] })),
  setActiveServer: (id) => set({ activeServerId: id }),
  clear: () => set({ servers: [], activeServerId: COMMUNITY_SERVER_ID }),
}));
